import { Component, Input, OnInit } from '@angular/core';
import type { ChartConfiguration, ChartOptions } from 'chart.js/auto';

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss'],
    standalone: false
})
export class PieChartComponent implements OnInit {

  @Input() type: string = 'pie';
  @Input() labels: string[] = [];
  @Input() values: number[] = [];

  public pieChartType: ChartConfiguration<'pie' | 'doughnut'>['type'] = 'pie';

  public pieChartData: ChartConfiguration<'pie' | 'doughnut'>['data'] = {
    labels: [],
    datasets: []
  };

  public pieChartOptions: ChartOptions<'pie'> = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: 10
    },
    plugins: {
      legend: {
        labels: {
          padding: 20
        }
      }
    }
  };

  public pieChartPlugins = [];

  constructor() { }

  ngOnInit(): void {

    // ✅ handle type (pie / doughnut)
    this.pieChartType = this.type === 'doughnut' ? 'doughnut' : 'pie';

    const backgroundColors = [
      '#0275d8',
      '#5cb85c',
      '#f0ad4e',
      '#d9534f',
      '#5bc0de',
      '#292b2c',
      '#f7f7f7'
    ];

    this.pieChartData = {
      labels: this.labels,
      datasets: [
        {
          data: this.values,
          backgroundColor: backgroundColors
        }
      ]
    };
  }
}